import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../../themes/svg/errorIcon';
import { enforcePhoneFormat, formatToPhone } from '../../../helpers/phoneNumberFormat';
import config from '../../../helpers/config';

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const validateEmail = (value, required = true) => {
  if (value === null || typeof value === 'undefined' || value.length === 0) {
    if (required) {
      return { message: 'value is required', valid: false };
    }
  } else if (!emailRegex.test(value)) {
    return { message: 'not a valid email address', valid: false };
  }
  return { message: '', valid: true };
};
const ValidationMessage = ({ message, valid }) => (!valid && <span className="danger" >* {message}</span>);

const styles = {
  errorBorder: {
    borderColor: '#c80000',
  },
};
function getEmailMessage() {
  let message = '';
  if (config.siteId === 3) {
    message = 'It was great talking with you today! I\'m here to help and truly appreciate your business. Here is your estimate with the information we discussed. Be sure to contact me directly with any questions. I want to ensure everything goes exactly as you wish and at the best possible price.';
  } else if (config.siteId === 11) {
    message = 'It was great speaking with you today! Here is your estimate based on what we discussed. I really appreciate you trusting me to help bring your project to life. Be sure to reach out to me directly with any questions or when you\'re ready to place your order.\n\nDo not reply to this email, as it will be sent to an unmonitored mailbox. Please reach out to me directly using my contact information below.';
  }
  return message;
}

function getDefaultState(props) {
  return {
    showError: false,
    customerName: '',
    email: '',
    message: getEmailMessage(),
    dcName: props.signature.name || '',
    dcEmail: props.signature.email || '',
    dcPhone: props.signature.phone || '',
    dcExtension: props.signature.extension || '',
    shareApiError: '',
    copyClicked: false,
  };
}

class CraftEmail extends Component {
  constructor(props) {
    super(props);
    this.state = getDefaultState(props);
  }

  onEventChange = (e) => {
    const key = e.target.name;
    this.setState({
      [key]: e.target.value,
    });
  };

  isValid = () => (
    validateEmail(this.state.email).valid &&
    validateEmail(this.state.dcEmail, false).valid
  );

  shareEstimate = () => {
    this.props.saveDCSignature(
      this.state.dcName,
      this.state.dcEmail,
      this.state.dcPhone,
      this.state.dcExtension,
    );

    this.props.shareEstimateAction(
      this.props.selection,
      this.state.customerName,
      this.state.email,
      this.state.message,
      this.state.dcName,
      this.state.dcEmail,
      this.state.dcPhone,
      this.state.dcExtension,
    );
  };

  copyLink = () => {
    document.getElementById('shareUrl').select();
    document.execCommand('Copy');
    this.setState(
      {
        copyClicked: true,
      },
      () => {
        setTimeout(() => {
          this.setState({ copyClicked: false });
        }, 5000);
      },
    );
  };

  formatNameList = (list) => {
    const len = list.length;
    if (len === 1) {
      return list[0];
    }

    let base = list.join();
    const lastEntry = list[len - 1];
    base = base.substring(0, base.indexOf(lastEntry));
    return `${base} and ${lastEntry}`;
  };

  render() {
    return (
      <div className="craftEmail">
        {this.state.showError && (
          <div className="shareModalNotSharedErrorMessage">
            <ErrorIcon />
            <span>
              Estimate not shared. Try again or copy link below.&nbsp;
              {this.state.shareApiError}
            </span>
          </div>
        )}
        <span className="shareList">
          You are sharing {this.formatNameList(this.props.estimateNames)}.
        </span>
        <h4 className="mb0">Customer Information</h4>
        <div className="shareModalGroup">
          <div className="shareModalInput">
            <label htmlFor="customerName" className="pl2 f7">Customer Name</label>
            <input
              name="customerName"
              type="text"
              placeholder="Customer's name"
              autoComplete="something-new"
              onChange={this.onEventChange}
            />
          </div>
          <div className="shareModalInput">
            <label htmlFor="email" className="pl2 f7">
              Customer Email
              <ValidationMessage {...validateEmail(this.state.email)} />
            </label>
            <input
              name="email"
              type="text"
              placeholder="Customer's email address"
              autoComplete="something-new"
              onChange={this.onEventChange}
            />
          </div>
        </div>
        <div className="shareModalGroup">
          <div className="shareModalInput">
            <label htmlFor="email" className="pl2 f7">Your Message to the Customer</label>
            <textarea
              name="message"
              rows="12"
              cols="50"
              value={this.state.message}
              className="shareModalMessage"
              onChange={this.onEventChange}
            />
          </div>
        </div>
        <hr />
        <h4 className="mb0">Your Information</h4>
        <div className="shareModalGroup">
          <div className="shareModalInput">
            <label htmlFor="dcName" className="pl2 f7">Your Name</label>
            <input
              name="dcName"
              type="text"
              placeholder="DC name"
              value={this.state.dcName}
              onChange={this.onEventChange}
            />
          </div>
          <div className="shareModalInput">
            <label htmlFor="dcEmail" className="pl2 f7">Your Email</label>
            <input
              name="dcEmail"
              type="text"
              placeholder="DC email address"
              value={this.state.dcEmail}
              onChange={this.onEventChange}
              style={!validateEmail(this.state.dcEmail, false).valid ? styles.errorBorder : null}
            />
          </div>
          <div className="shareModalInput">
            <label htmlFor="dcPhone" className="pl2 f7">Your Phone Number</label>
            <input
              name="dcPhone"
              type="text"
              placeholder="DC phone number"
              value={this.state.dcPhone}
              onChange={this.onEventChange}
              onKeyDown={enforcePhoneFormat}
              onKeyUp={formatToPhone}
              maxLength={14}
            />
          </div>
          <div className="shareModalInput">
            <label htmlFor="dcExtension" className="pl2 f7">Your Extension</label>
            <input
              name="dcExtension"
              type="text"
              placeholder="DC extension"
              value={this.state.dcExtension}
              onChange={this.onEventChange}
              onKeyDown={enforcePhoneFormat}
              maxLength={6}
            />
          </div>
        </div>
        <button
          className="btn btn-primary full-width"
          type="submit"
          onClick={this.shareEstimate}
          disabled={!this.isValid()}
        >
          Share
        </button>
        <hr />
        <div className="pa2">
          <label htmlFor="shareUrl" className="pl2 shareModalLinkToThisEstimateLabel">
            Link to Estimate(s)
            {this.state.copyClicked && <span className="copiedStatus"> (Copied)</span>}
          </label>
          <div
            className={[
              'shareModalEstimateLinkContainer',
              this.state.copyClicked ? 'clicked' : '',
            ].join(' ')}
          >
            <input
              type="text"
              id="shareUrl"
              className={['shareModalEstimateLink', this.state.copyClicked ? 'clicked' : ''].join(' ')}
              value={this.props.shareUrl}
              readOnly="true"
            />
            <div
              className={['shareModalClickToCopy', this.state.copyClicked ? 'clicked' : ''].join(' ')}
              onClick={this.copyLink}
              role="button"
              tabIndex="-1"
            >
              Click to copy
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CraftEmail.propTypes = {
  selection: PropTypes.arrayOf(PropTypes.string).isRequired,
  estimateNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  shareUrl: PropTypes.string.isRequired,
  shareEstimateAction: PropTypes.func.isRequired,
  saveDCSignature: PropTypes.func.isRequired,
  signature: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    extension: PropTypes.string,
  }),
};

CraftEmail.defaultProps = {
  signature: {
    name: '',
    email: '',
    phone: '',
    extension: '',
  },
};

export default CraftEmail;
